import { useComponentsQuery } from './queries/cluster-management/useComponentsQuery';
import { useComponentStatusQuery } from './queries/cluster-management/useComponentStatusQuery';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type CastwareAgentStatusArgs = {
  name: string;
  enabled?: boolean;
};

export const useCastwareAgentStatus = ({
  name,
  enabled = true,
}: CastwareAgentStatusArgs) => {
  const { cluster } = useCluster();

  const {
    isLoading: isLoadingComponent,
    data: component,
    error: errorComponent,
    refetch: refetchComponent,
  } = useComponentsQuery({
    select: (data) => {
      const components = data.components.filter(
        (component) => component.name === name
      );

      if (components.length === 0) {
        return undefined;
      }

      return components[0];
    },
    // disable checking on organization level reports, it's not supported yet
    enabled: enabled && Boolean(cluster.id),
  });

  const {
    isLoading: isLoadingComponentStatus,
    data: componentStatus,
    error: errorComponentStatus,
    refetch: refetchComponentStatus,
  } = useComponentStatusQuery({
    clusterId: cluster.id,
    componentId: component?.id,
    enabled:
      enabled && !isLoadingComponent && Boolean(cluster.id && component?.id),
    select: (data) => {
      return data.status;
    },
  });

  const isInstalled =
    !!componentStatus &&
    !['STATUS_UNSPECIFIED', 'DISCONNECTED', 'ERROR'].includes(componentStatus);

  return {
    isLoading: isLoadingComponent || isLoadingComponentStatus,
    error: errorComponent || errorComponentStatus,
    data: componentStatus,
    isInstalled,
    refetch: () => Promise.all([refetchComponent(), refetchComponentStatus()]),
  };
};
